import script from "./LoanManagement.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoanManagement.vue?vue&type=script&setup=true&lang=ts"

import "./LoanManagement.vue?vue&type=style&index=0&id=24f0fb7b&lang=scss"

const __exports__ = script;

export default __exports__